export const emissionSlotsPerScope = (frequency) => {
  const f = String(frequency || "yearly");
  return f === "monthly" ? 12 : f === "quarterly" ? 4 : 1;
};

export const calcNxplanProgress = ({
  form = {},
  freq = {},
  emissions = {},
  baseline = {},
}) => {
  const requiredKeys = (() => {
    const keys = [
      "organizationBoundary",
      "baseYear",
      "targetYear",
      "reportingYear",
      "isSBTi",
    ];
    if (form.isSBTi === "yes") {
      keys.push("sbtiTemperature");
      keys.push("targetType");
      keys.push("regressionModel");
    } else if (form.isSBTi === "no") {
      keys.push("targetReduction");
    }
    return keys;
  })();

  const baseFilled = requiredKeys.reduce((acc, key) => {
    const value = form[key];
    if (key === "targetReduction") {
      const n = Number(value);
      return acc + (!Number.isNaN(n) && value !== "" ? 1 : 0);
    }
    return acc + (String(value ?? "").trim().length > 0 ? 1 : 0);
  }, 0);

  const scopeKeys = ["scope1", "scope2", "scope3"];
  const emissionsRequired = scopeKeys.reduce(
    (sum, key) => sum + emissionSlotsPerScope(freq[key] || "yearly"),
    0,
  );
  const emissionsFilled = scopeKeys.reduce((sum, key) => {
    const size = emissionSlotsPerScope(freq[key] || "yearly");
    const arrRaw = emissions[key] || [];
    const arr = Array.isArray(arrRaw) ? arrRaw.slice(0, size) : [];
    const filled = arr.filter((item) => {
      const val =
        typeof item === "object" && item !== null ? item.emission : item;
      const n = Number(val);
      return String(val ?? "").trim() !== "" && !Number.isNaN(n);
    }).length;
    return sum + filled;
  }, 0);

  const baselineRequired = scopeKeys.length;
  const baselineFilled = scopeKeys.reduce((sum, key) => {
    const raw = baseline?.[key];
    const str = String(raw ?? "").trim();
    if (!str) return sum;
    const n = Number(str);
    return sum + (!Number.isNaN(n) && n >= 0 ? 1 : 0);
  }, 0);

  const total =
    (requiredKeys.length || 1) + emissionsRequired + baselineRequired;
  const filled = baseFilled + emissionsFilled + baselineFilled;
  return Math.round((filled / Math.max(1, total)) * 100);
};

export const calculateNxmapProgress = ({
  completedSteps = {},
  totalSteps = 3,
} = {}) => {
  const total = Math.max(1, Number(totalSteps) || 3);
  const done = Object.values(completedSteps || {}).filter(Boolean).length;
  return Math.round((done / total) * 100);
};
